var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"sg-textfield-label"},[_c('span',{staticClass:"sg-textfield-label-caption",domProps:{"innerHTML":_vm._s(_vm.$t('general.currency'))}})]),_c('vrm-dropdown',{attrs:{"value":_vm.mappedValue,"search-enabled":true,"options":_vm.currencies},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }